import { Lock } from 'lucide-react'
import ErrorCard from '../NotFoundCard/ErrorCard'

const NotAuthorizedCard: React.FC = () => {
  return (
    <ErrorCard
      title={
        <div className="flex justify-center mb-2">
          <Lock size={32} strokeWidth={2.5} />
        </div>
      }
      description="You do not have permission to access this page."
      legend="Please talk to an admin on your team to update your seat"
    />
  )
}

export default NotAuthorizedCard
